import React from 'react';
import './BlogHero.css';

export default function BlogHero({ featured }) {
  if (!featured) return null;

  return (
    <section className="bh">
      <div
        className="bh__bg"
        style={{ backgroundImage: `url(${featured.cover_image || 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=1400&q=85'})` }}
      />
      <div className="bh__overlay" />

      <div className="bh__inner">
        <div className="bh__content">
          <span className="bh__category">{featured.category}</span>
          <h1 className="bh__title">{featured.title}</h1>
          <p className="bh__excerpt">{featured.excerpt}</p>
          <div className="bh__meta">
            <span className="bh__author">{featured.author}</span>
            <span className="bh__sep">·</span>
            <span className="bh__date">
              {new Date(featured.created_at).toLocaleDateString('en-ZA', {
                day: 'numeric', month: 'long', year: 'numeric'
              })}
            </span>
          </div>
          <a href={`/blog/${featured.slug}`} className="bh__btn">
            Read The Drop
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12 5 19 12 12 19"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}